module.exports = __webpack_public_path__ + "media/images/github-copilot-plan_browser-window-3d08e1adfc6e1e44c41862f7f7aa6442.png";